import { render } from "./SpacesUser.vue?vue&type=template&id=a7378324&scoped=true&ts=true"
import script from "./SpacesUser.vue?vue&type=script&lang=ts"
export * from "./SpacesUser.vue?vue&type=script&lang=ts"

import "./SpacesUser.vue?vue&type=style&index=0&id=a7378324&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7378324"]])

export default __exports__